import React, { Component } from 'react';
import InsuranceSearchForm from '../containers/InsuranceSearchFormContainer';
import InsuranceTitle from '../components/InsuranceTitle';
import InsuranceTabs from '../components/InsuranceTabs';
import InsuranceFeatures from '../components/InsuranceFeatures';
import scrollToComponent from 'react-scroll-to-component';
import {MorePossibilitiesModule} from 'polisua-react-modules/index.esm';

class KascoFind extends Component {
  constructor(props) {
    super(props);

    this._searchCarNumberRef = '';
  }

  // скролим к компоненту
  onScrollToComponent = () => {
    scrollToComponent(this._searchCarNumberRef, {
      duration: 1000,
      ease: 'inOutExpo'
    });
  }

  // получаем ref компонента
  getSearchCarNumberRef = (node) => {
    this._searchCarNumberRef = node;
  }

  render() {
    return (
      <div>
        <InsuranceTitle locale={this.props.locale} />
        <InsuranceSearchForm locale={this.props.locale} getSearchCarNumberRef={this.getSearchCarNumberRef} addToDataLayer={this.props.addToDataLayer} />
        <InsuranceTabs locale={this.props.locale} onScrollToComponent={this.onScrollToComponent} />
        <section id="polis-about">
          <div className="container">
            <InsuranceFeatures locale={this.props.locale} />
            <MorePossibilitiesModule lang={this.props.locale === 'ua' ? 'uk' : 'ru'} />
          </div>
        </section>
      </div>
    );
  }
}

export default KascoFind;
